skrilla.controller('skrPurchasesCtrl', function ($scope, cacheService, modalService) {
    $scope.key = "skrPurchases";
    $scope.purchases = cacheService.getObjectOrElse("skrPurchasesTable", []);

    $scope.open = function(purchase){
        cacheService.registerObject("skrPurchaseDetails", purchase);
        modalService.openModal("/views/skrPurchases/skrPurchaseModal.html", true, 'lg', true, true);
    }



});